import { formatDate as formatDateCentral } from './formatters';

/**
 * Formatiert ein Datum in ein lesbares deutsches Format.
 * Delegiert an das zentrale {@link formatDateCentral} (M-G, architecture-ux-density-v2.md §14).
 * @param date - Das zu formatierende Datum
 * @returns Formatiertes Datum im Format "DD.MM.YYYY"
 */
export const formatDate = (date: Date): string => {
  return formatDateCentral(date);
};

/**
 * Übersetzt Workflow-Status ins Deutsche
 * @param status - Der zu übersetzende Status (oder undefined)
 * @returns Die deutsche Übersetzung des Status
 */
export const getStatusTranslation = (status?: string): string => {
  if (!status) return 'Unbekannt';
  
  // Lowercase für konsistenten Vergleich
  const statusLower = status.toLowerCase();
  
  switch (statusLower) {
    case 'draft': return 'Entwurf';
    case 'sent': return 'Versendet';
    case 'accepted': return 'Akzeptiert';
    case 'invoiced': return 'In Rechnung gestellt';
    case 'paid': return 'Bezahlt';
    case 'overdue': return 'Überfällig';
    case 'rejected': return 'Abgelehnt';
    case 'canceled': return 'Storniert';
    case 'issued': return 'Ausgestellt';
    case 'completed': return 'Abgeschlossen';
    case 'partially_paid': return 'Teilweise bezahlt';
    case 'pending_approval': return 'Ausstehende Genehmigung';
    case 'approved': return 'Genehmigt';
    case 'expired': return 'Abgelaufen';
    case 'revised': return 'Überarbeitet';
    case 'pending_submission': return 'Ausstehende Einreichung';
    case 'received': return 'Empfangen';
    case 'custom': return 'Benutzerdefiniert';
    default: return status.charAt(0).toUpperCase() + status.slice(1);
  }
}; 